import { mapGetters } from 'vuex';
import { convertSimpleTypeArrayToObjectArray, unflatten, filterArraysFromPreviousStepData, isMappingString } from '@/utils/helpers';
import ParamsService from '@/utils/ParamsService';
import get from 'lodash/get';
import IsRequiredFieldComputedMixin from '../mixins/IsRequiredFieldComputedMixin';
import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import { configurationsMappingBlocksUUIDs } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
// this mixin need to be used with WidgetFieldMixin

export default {
	props: {
		previousSteps: { type: Object },
	},
	mixins: [IsRequiredFieldComputedMixin],
	computed: {
		...mapGetters('widgetEditor', ['editField']),
		...mapGetters('nodes', ['getPreviousStepDataForNodeByUUID']),
		...mapGetters([replaceInsertDataStringDictionary.fullPath, configurationsMappingBlocksUUIDs.fullPath]),
		placeholderValueLocal: {
			set(value) {
				this.$emit('update:placeholderValue', value);
			},
			get() {
				return this.placeholderEnabled ? this.placeholderValue : '';
			},
		},
		previousStepsEditMode() {
			const previousStepData = this.getPreviousStepDataForNodeByUUID(this.stepUUID);
			const filteredPreviousStepData = filterArraysFromPreviousStepData(previousStepData)[this.sourcePath];
			return filteredPreviousStepData;
		},
		preStep() {
			let previousStepResult = this.fieldOptions.step_id.value;
			if (isMappingString(previousStepResult)) {
				if (!this.stepUUID || !this.previousSteps) {
					return [];
				}
				// Handle the {{ }} mapping.
				const key = ParamsService.removeBracketsFromValue(this.fieldOptions.step_id.value);
				const unflattens = unflatten(this.previousSteps);
				previousStepResult = get(unflattens, key);
			}

			const res = previousStepResult ? Object.values(previousStepResult) : [];
			return convertSimpleTypeArrayToObjectArray(res);
		},
		stepUUID() {
			return ParamsService.extractNodeUUIDFromValue(this.fieldOptions.step_id.value);
		},
		sourcePath() {
			return ParamsService.extractPathFromValue(
				this.fieldOptions.step_id.value,
				this[replaceInsertDataStringDictionary.fullPath],
				this[configurationsMappingBlocksUUIDs.fullPath]
			);
		},
		userSelectionEnabled() {
			return this.fieldOptions.user_selection?.enabled;
		},
		isSearch() {
			return this.fieldOptions.find.enabled;
		},
		isMultipleSelection() {
			return this.fieldOptions.user_selection?.multiple;
		},
		amountSelected() {
			return this.value ? (Array.isArray(this.value) ? this.value.length : 1) : 0;
		},
		customFieldValidation() {
			return [() => !this.userSelectionEnabled || !this.isRequired || this.amountSelected > 0 || 'This field is required...'];
		},
	},
	methods: {},
	data() {
		return {
			searchText: '',
		};
	},
};
